import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../App.css';

function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const hasTrackedConversion = useRef(false);

  useEffect(() => {
    if (hasTrackedConversion.current) {
      return;
    }

    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17867330056/A3uOCJz86-obEIik58dC',
        transaction_id: sessionId || ''
        // new_customer: true /* calculate dynamically, populate with true/false */,
      });
      hasTrackedConversion.current = true;
    }

    // Track purchase in PostHog
    if (window.posthog) {
      const savedResults = sessionStorage.getItem('money_mirror_results');
      const parsedResults = savedResults ? JSON.parse(savedResults) : null;
      window.posthog.capture('purchase_completed', {
        session_id: sessionId,
        personality_type: parsedResults?.profile || '',
        personality_name: parsedResults?.personality?.name || ''
      });
    }
  }, [sessionId]);
  
  // Helper function to load state from sessionStorage
  const loadStateFromSessionStorage = () => {
    try {
      const savedResults = sessionStorage.getItem('money_mirror_results');
      const savedAnswers = sessionStorage.getItem('money_mirror_answers');
      const savedSelfie = sessionStorage.getItem('money_mirror_selfie');
      
      return {
        results: savedResults ? JSON.parse(savedResults) : null,
        answers: savedAnswers ? JSON.parse(savedAnswers) : null,
        selfie: savedSelfie || null
      };
    } catch (error) {
      console.error('Error loading state from sessionStorage:', error);
      return { results: null, answers: null, selfie: null };
    }
  };
  
  // Function to navigate back to results with saved state
  const handleBackToResults = () => {
    const savedState = loadStateFromSessionStorage();
    if (savedState.results || savedState.answers?.length > 0) {
      navigate('/results', { 
        state: { 
          results: savedState.results,
          answers: savedState.answers,
          selfie: savedState.selfie
        } 
      });
    } else {
      // Fallback: navigate without state if nothing is saved
      navigate('/results');
    }
  };

  return (
    <div className="app-container">
      <div className="blue-gradient-overlay"></div>
      <div className="main-content results-content">
        <div className="title-section">
          <p className="title-line-1">PAYMENT SUCCESSFUL</p>
          <p className="title-line-2">Thank You</p>
        </div>
        <div className="personality-summary" style={{ marginTop: '40px' }}>
          <p className="summary-text">
            Your full report has been sent to your email.
          </p>
          <p className="summary-text" style={{ marginTop: '20px' }}>
            Remember, money scripts are not destiny. They are stories. And stories, once seen clearly, can change.
          </p>
          {sessionId && (
            <p className="summary-text" style={{ marginTop: '20px', fontSize: '14px', opacity: 0.7 }}>
              Session ID: {sessionId}
            </p>
          )}
        </div>
        <div className="results-actions" style={{ marginTop: '60px' }}>
          <button 
            className="primary-button"
            onClick={handleBackToResults}
          >
            Back to Results
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessPage;



